import { jsx as n, jsxs as o, Fragment as M } from "react/jsx-runtime";
import O from "./productNutritionTab.module.js";
import { Accordion as he } from "../Accordion/index.js";
import { ContainmentBlock as x } from "../ContainmentBlock/index.js";
import { allContainmentsFreeFrom as D, formatSIUnit as ee, getEnergyContentDisplayValue as ne, formatDailyValueIntake as S, isNutrientSubset as ie, formatQuantityContainedWithPrecision as te, getMeasurementPrecision as re, formatQuantityContained as se, transformNutritionalClaims as _e, transformAllergens as de } from "../../utils/transformation.js";
import { PreparationStates as d } from "../../types/types.js";
import { useTranslation as ye } from "../../hooks/useTranslation.js";
import "react";
import "../Context/index.js";
import "../IconButton/index.js";
import "../../pagination-BeOG0tbT.js";
import "../ProductTable/TableRowGroup.js";
import { SectionBlock as c } from "../SectionBlock/SectionBlock.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
const Ie = ({
  productData: e,
  className: le,
  language: h
}) => {
  var L, W, B, K, Q, V, $, J, G, p, w, z, H, X, Y, Z, a;
  const { t: _, safeTranslate: U, tryTranslate: me } = ye();
  if (!((L = e == null ? void 0 : e.nutritional_informations) != null && L[0]) && (!((W = e == null ? void 0 : e.allergens) != null && W[0]) || D(e)) && !((B = e == null ? void 0 : e.diets) != null && B[0]))
    return null;
  const oe = () => {
    const { allergens: s } = e || {};
    return (s == null ? void 0 : s[0]) && !D(e) && /* @__PURE__ */ o(c, { title: _("allergens"), children: [
      Object.entries(de(e, h)).map(
        ([i, l]) => /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n(
          x,
          {
            header: l.map((t) => t.containmentText),
            items: l.map((t) => t.value),
            isReadMore: l.map((t) => t.value).length > 4
          }
        ) }, i)
      ),
      /* @__PURE__ */ n("p", { children: _("allergens_disclaimer") })
    ] });
  }, v = e == null ? void 0 : e.nutritional_informations.reduce((s, i) => {
    const l = i.nutrient_basis_quantity;
    return l && (s[l] = s[l] || [], s[l].push(i)), s;
  }, {});
  return (((K = e == null ? void 0 : e.nutritional_informations) == null ? void 0 : K[0]) || ((Q = e == null ? void 0 : e.allergens) == null ? void 0 : Q[0]) || ((V = e == null ? void 0 : e.diets) == null ? void 0 : V[0])) && /* @__PURE__ */ n("div", { className: le, children: /* @__PURE__ */ n(
    he,
    {
      className: O.accordion,
      header: _("nutritional_content"),
      headingLevel: "h2",
      children: /* @__PURE__ */ o("div", { className: O.accordionContent, children: [
        (($ = e == null ? void 0 : e.nutritional_informations[0]) == null ? void 0 : $.preparation_states) && ((G = (J = e == null ? void 0 : e.nutritional_informations) == null ? void 0 : J[0]) == null ? void 0 : G.quantity_contained) && (e == null ? void 0 : e.nutritional_informations.some(
          (s) => s.preparation_states.some(
            (i) => i.code === d.PREPARED || i.code === d.UNSPECIFIED
          )
        )) && /* @__PURE__ */ n(M, { children: Object.entries(v).map(
          ([s, i], l) => {
            var t, b, P;
            return /* @__PURE__ */ n(c, { children: /* @__PURE__ */ o("table", { children: [
              /* @__PURE__ */ n("thead", { children: /* @__PURE__ */ o("tr", { children: [
                /* @__PURE__ */ n("th", { children: _("nut_table_nutritional_content") }),
                /* @__PURE__ */ n("th", { children: `Per ${s} ${ee(
                  (P = (b = (t = i[0]) == null ? void 0 : t.nutrient_basis_quantity_uoms) == null ? void 0 : b[0]) == null ? void 0 : P.code
                )}` }),
                /* @__PURE__ */ n("th", { children: "% RDA" })
              ] }) }),
              /* @__PURE__ */ n("tbody", { children: i.filter(
                (r) => r.preparation_states.some(
                  (m) => m.code === d.PREPARED || m.code === d.UNSPECIFIED
                )
              ).sort(
                (r, m) => Number(r.nutrient_sequence) - Number(m.nutrient_sequence)
              ).map((r) => {
                var f, R, C, F, N, q, T, A, u, k, g, I;
                const m = Number(
                  r.quantity_contained
                ), y = ((R = (f = r.quantity_contained_uoms) == null ? void 0 : f[0]) == null ? void 0 : R.code) || "", j = r.daily_value_intake_percent, E = ne(i, h);
                return y === "KJ" ? null : y === "KCAL" ? /* @__PURE__ */ o("tr", { children: [
                  /* @__PURE__ */ n("td", { children: U(
                    (F = (C = r.nutrient_types) == null ? void 0 : C[0]) == null ? void 0 : F.code
                  ) }),
                  /* @__PURE__ */ n("td", { children: E.energyContentForDisplayPrepared.display_string }),
                  /* @__PURE__ */ n("td", { children: S(
                    E.energyContentForDisplayPrepared.daily_value_intake ?? null,
                    h
                  ) })
                ] }, (q = (N = r.nutrient_types) == null ? void 0 : N[0]) == null ? void 0 : q.code) : /* @__PURE__ */ o("tr", { children: [
                  /* @__PURE__ */ o("td", { children: [
                    ie(
                      (A = (T = r.nutrient_types) == null ? void 0 : T[0]) == null ? void 0 : A.code
                    ) && /* @__PURE__ */ n(M, { children: " " }),
                    U(
                      (k = (u = r.nutrient_types) == null ? void 0 : u[0]) == null ? void 0 : k.code
                    )
                  ] }),
                  /* @__PURE__ */ n("td", { children: te(
                    se(
                      m,
                      y,
                      h
                    ),
                    re(r)
                  ) }),
                  /* @__PURE__ */ n("td", { children: S(
                    j,
                    h
                  ) })
                ] }, (I = (g = r.nutrient_types) == null ? void 0 : g[0]) == null ? void 0 : I.code);
              }) })
            ] }) }, l);
          }
        ) }),
        ((p = e == null ? void 0 : e.nutritional_informations[0]) == null ? void 0 : p.preparation_states) && ((z = (w = e == null ? void 0 : e.nutritional_informations) == null ? void 0 : w[0]) == null ? void 0 : z.quantity_contained) && (e == null ? void 0 : e.nutritional_informations.some(
          (s) => s.preparation_states.some(
            (i) => i.code === d.UNPREPARED
          )
        )) && /* @__PURE__ */ n(M, { children: Object.entries(v).map(
          ([s, i], l) => {
            var t, b, P;
            return /* @__PURE__ */ n(c, { children: /* @__PURE__ */ o("table", { children: [
              /* @__PURE__ */ n("thead", { children: /* @__PURE__ */ o("tr", { children: [
                /* @__PURE__ */ n("th", { children: i.some(
                  (r) => r.preparation_states.some(
                    (m) => m.code === d.PREPARED || m.code === d.UNSPECIFIED
                  )
                ) ? _(
                  "nut_table_nutritional_content_unprepared"
                ) : _("nut_table_nutritional_content") }),
                /* @__PURE__ */ n("th", { children: `Per ${s} ${ee(
                  (P = (b = (t = i[0]) == null ? void 0 : t.nutrient_basis_quantity_uoms) == null ? void 0 : b[0]) == null ? void 0 : P.code
                )}` }),
                /* @__PURE__ */ n("th", { children: "% RDA" })
              ] }) }),
              /* @__PURE__ */ n("tbody", { children: i.filter(
                (r) => r.preparation_states.some(
                  (m) => m.code === d.UNPREPARED
                )
              ).sort(
                (r, m) => Number(r.nutrient_sequence) - Number(m.nutrient_sequence)
              ).map((r) => {
                var f, R, C, F, N, q, T, A, u, k, g, I;
                const m = Number(
                  r.quantity_contained
                ), y = ((R = (f = r.quantity_contained_uoms) == null ? void 0 : f[0]) == null ? void 0 : R.code) || "", j = r.daily_value_intake_percent, E = ne(i, h);
                return y === "KJ" ? null : y === "KCAL" ? /* @__PURE__ */ o("tr", { children: [
                  /* @__PURE__ */ n("td", { children: U(
                    (F = (C = r.nutrient_types) == null ? void 0 : C[0]) == null ? void 0 : F.code
                  ) }),
                  /* @__PURE__ */ n("td", { children: E.energyContentForDisplayUnprepared.display_string }),
                  /* @__PURE__ */ n("td", { children: S(
                    E.energyContentForDisplayUnprepared.daily_value_intake ?? null,
                    h
                  ) })
                ] }, (q = (N = r.nutrient_types) == null ? void 0 : N[0]) == null ? void 0 : q.code) : /* @__PURE__ */ o("tr", { children: [
                  /* @__PURE__ */ o("td", { children: [
                    ie(
                      (A = (T = r.nutrient_types) == null ? void 0 : T[0]) == null ? void 0 : A.code
                    ) && /* @__PURE__ */ n(M, { children: " " }),
                    U(
                      (k = (u = r.nutrient_types) == null ? void 0 : u[0]) == null ? void 0 : k.code
                    )
                  ] }),
                  /* @__PURE__ */ n("td", { children: te(
                    se(
                      m,
                      y,
                      h
                    ),
                    re(r)
                  ) }),
                  /* @__PURE__ */ n("td", { children: S(
                    j
                  ) })
                ] }, (I = (g = r.nutrient_types) == null ? void 0 : g[0]) == null ? void 0 : I.code);
              }) })
            ] }) }, l);
          }
        ) }),
        oe(),
        /* @__PURE__ */ n(c, { children: /* @__PURE__ */ n("div", { className: O.destyleList, children: e && Object.entries(
          _e(
            e,
            me,
            h
          )
        ).sort((s, i) => s[0] === "PREFORMATTED" && i[0] === "PREFORMATTED" ? 0 : s[0] === "PREFORMATTED" ? -1 : i[0] === "PREFORMATTED" ? 1 : 0).map(([s, i], l) => /* @__PURE__ */ n("div", { children: l === 0 ? /* @__PURE__ */ n(c, { title: _("nutritional_claims"), children: /* @__PURE__ */ n(
          x,
          {
            header: i.map(
              (t) => t.containmentText
            ),
            items: i.map((t) => t.value),
            isReadMore: i.length > 4
          }
        ) }) : /* @__PURE__ */ n(c, { children: /* @__PURE__ */ n(
          x,
          {
            header: i.map(
              (t) => t.containmentText
            ),
            items: i.map((t) => t.value),
            isReadMore: i.length > 4
          }
        ) }) }, s)) }) }),
        ((H = e == null ? void 0 : e.diets) == null ? void 0 : H[0]) && (((Y = (X = e == null ? void 0 : e.diets) == null ? void 0 : X[0]) == null ? void 0 : Y.diet_types) || ((a = (Z = e == null ? void 0 : e.diets) == null ? void 0 : Z[0]) == null ? void 0 : a.sub_diets)) && /* @__PURE__ */ n(c, { title: _("diets"), children: /* @__PURE__ */ n("div", { className: O.destyleList, children: /* @__PURE__ */ o("ul", { children: [
          e.diets.map((s) => {
            const i = s.diet_types.filter(
              (t) => t.language === h
            );
            return (i.length ? i : s.diet_types.filter(
              (t) => t.language === "fi"
            )).map((t) => /* @__PURE__ */ n("li", { children: t.value }, t.code));
          }),
          e.diets.map((s) => {
            const i = s.sub_diets.filter(
              (t) => t.language === h
            );
            return (i.length ? i : s.sub_diets.filter(
              (t) => t.language === "fi"
            )).map((t) => /* @__PURE__ */ n("li", { children: t.value }, t.code));
          })
        ] }) }) })
      ] })
    }
  ) });
};
export {
  Ie as ProductNutritionTab
};
